import { useCompanyStore } from '@/stores/company';
import type { AdyenBalanceAccount } from '@/types';

// A wallet's share is stored in basis points: 100 is 1%.
export const BASIS_POINTS_PER_WHOLE = 10000;

export const formatShare = (basisPoints: number) => {
  const { isUk } = useCompanyStore();

  return new Intl.NumberFormat(isUk ? 'en-GB' : 'nl', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(basisPoints / BASIS_POINTS_PER_WHOLE);
};

// The main wallet has no label of its own, so it goes by the company name.
export const walletName = (
  balanceAccount: Pick<AdyenBalanceAccount, 'label'>,
) => balanceAccount.label || useCompanyStore().company.name;
